const HEADLINE = 'Essa flor não está no nosso jardim.'
const MESSAGE = 'O endereço mudou ou nunca floresceu por aqui.'
const CATALOG_HREF = '/catalogo' as const
const CATALOG_LABEL = 'Ver o catálogo'

export function useNotFoundFloraModel() {
  return {
    headline: HEADLINE,
    message: MESSAGE,
    catalogHref: CATALOG_HREF,
    catalogLabel: CATALOG_LABEL,
  }
}
